// removed by extract-text-webpack-plugin
module.exports = {"merge-buttons":"merge-documents-modal__merge-buttons___1rhiM","grid-container":"merge-documents-modal__grid-container___3gOKP","error-container":"merge-documents-modal__error-container___3g2xL"};


//////////////////
// WEBPACK FOOTER
// ./src/scss/components/documents/merge-documents-modal.scss
// module id = 1329
// module chunks = 0